export { default } from './ActiveFilters';



// WEBPACK FOOTER //
// ./app/components/search/ActiveFilters/index.js